import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopMedical } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const Pims = () => {
    const pims = useSelector((state) => state.practice.practice?.pims);
    return (
        <Col md={12} className="d-flex px-3 py-2" title="Practice PIMS">
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faLaptopMedical}
                size="lg"
            />
            &emsp;{pims || 'No PIMS Set'}
        </Col>
    );
};

export default Pims;
